import React from 'react';

function Splash() {
  return (
    <div className="min-h-screen w-full flex">
      <div className="text-center m-auto w-full max-w-sm loader-wrapper">
        <div className="text-neutral-600">Loading...</div>
        <div className="loaderBar">
          <div className="loaderBarInner" />
        </div>
      </div>
    </div>
  );
}

export default Splash;
